import { render, staticRenderFns } from "./ShiftSwapCreationDialog.vue?vue&type=template&id=af0a100a&"
import script from "./ShiftSwapCreationDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftSwapCreationDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports